(function (global) {
  'use strict';

  // Product eligibility and codes are taken from the live Shopify discount audit.
  // Shopify remains responsible for all prices, eligibility and discount amounts.
  const families = [{"name":"summer","codes":["KLAIMSETS2","KLAIMSETS3"],"productIds":[10476987220304,10476980601168,10476988596560,10476976341328,10476974309712,10476984009040,10476982075728,10476974539088,10571596890448,10571596202320,10506800759120,10571597513040,10571597152592,10571596530000,10571595612496,10577024450896,10506800922960,10689150058832,10577024614736]},{"name":"winter","codes":["KLAIMWINTER2","KLAIMWINTER3"],"productIds":[10633627435344,10633667412304,10633667576144,10633668755792,10633668952400,10633669083472,10633669312848,10687081644368,10687081677136,10687081709904,10687081742672]},{"name":"slides","codes":["YEEZYSLIDE2","YEEZYSLIDE3"],"productIds":[10568014102864,10568014135632,10568014168400]}];
  const normalize = (code) => String(code || '').trim().toUpperCase();
  const managedCodes = families.flatMap((family) => family.codes);
  const shopRoot = global.Shopify?.routes?.root || '/';
  const root = shopRoot.endsWith('/') ? shopRoot : `${shopRoot}/`;

  function quantityFor(cart, family) {
    return (cart.items || []).reduce((quantity, item) => {
      return family.productIds.includes(Number(item.product_id))
        ? quantity + Number(item.quantity || 0)
        : quantity;
    }, 0);
  }

  function desiredCodes(cart) {
    return families.map((family) => {
      const quantity = quantityFor(cart, family);
      return quantity >= 3 ? family.codes[1] : quantity >= 2 ? family.codes[0] : '';
    }).filter(Boolean);
  }

  function applicable(cart, code) {
    return (cart.discount_codes || []).some((discount) => discount.applicable === true && normalize(discount.code) === normalize(code));
  }

  function codesFor(cart) {
    const customerCodes = (cart.discount_codes || [])
      .filter((discount) => discount.applicable === true && !managedCodes.includes(normalize(discount.code)))
      .map((discount) => normalize(discount.code));
    return [...new Set([...customerCodes, ...desiredCodes(cart)])];
  }

  async function request(url, options = {}) {
    const response = await fetch(url, {
      ...options,
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest', ...options.headers }
    });
    const state = await response.json();
    if (!response.ok || state.status || state.errors) {
      throw new Error(state.description || state.message || 'The bundle discount could not be confirmed. Please check your bag.');
    }
    return state;
  }

  const manager = {
    version: 'shopify-codes-v1',
    codes: managedCodes,
    families,
    pending: Promise.resolve(),
    getQuantity: (cart) => quantityFor(cart, families[0]),
    getDesiredCodes: desiredCodes,
    getCodes: codesFor,
    isApplicable: applicable,

    sync({ sections = [] } = {}) {
      // Serialize calls so a second add/remove cannot skip a required code update.
      const operation = this.pending.catch(() => {}).then(async () => {
        const cart = await request(`${root}cart.js`);
        const codes = codesFor(cart);
        const state = await request(global.routes?.cart_update_url || `${root}cart/update.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: codes.join(','), sections, sections_url: global.location.pathname })
        });
        const rejected = desiredCodes(cart).filter((code) => !applicable(state, code));
        if (rejected.length) {
          throw new Error(`Shopify could not apply ${rejected.join(', ')} to this bag. Check the promotion requirements and discount combinations before checkout.`);
        }
        return state;
      });
      this.pending = operation;
      return operation;
    }
  };

  global.KlaimBundleDiscounts = manager;
  // Keep the existing cart quantity and summer-builder integration working.
  global.KlaimEssentialsSetDiscount = manager;
})(window);
